import styled from 'styled-components';

import { Col } from 'antd';

export default styled(Col)`
  width: 100%;
  max-width: 320px;
  margin-top: 5em;
`;
